import { render, staticRenderFns } from "./suketBerdomisili.vue?vue&type=template&id=2d1c1185&"
import script from "./suketBerdomisili.vue?vue&type=script&lang=js&"
export * from "./suketBerdomisili.vue?vue&type=script&lang=js&"
import style0 from "./suketBerdomisili.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QAvatar,QBtn,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QDialog,QCard,QCardSection,QInput,QSelect,QFile,QMarkupTable,QCardActions,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QAvatar,QBtn,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QDialog,QCard,QCardSection,QInput,QSelect,QFile,QMarkupTable,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
